'use client';
import React, { PropsWithChildren } from 'react';
import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';
import { useMantineTheme } from '@mantine/core';

const ProgressProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const theme = useMantineTheme();

  return (
    <>
      {children}
      <ProgressBar
        height="2px"
        color={theme.primaryColor}
        options={{ showSpinner: false }}
        shallowRouting
      />
    </>
  );
};

export default ProgressProvider;
